import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Box, Button, LinearProgress, TextField } from '@material-ui/core';
import InputMask from 'react-input-mask';
import ReCAPTCHA from 'react-google-recaptcha';
import { consts } from '../../common/consts';
import errorsymbol from '../../assets/images/errorsymbol.png';
import { makeStyles, Theme } from '@material-ui/core/styles';
import api from '../../store/api';
import PCRObservationChartPDF from './SubFormWidgets/PCRObservationChartPDF';

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontFamily: "Lato",
    '& .container': {
      padding: "31px",
      marginTop: "44px",
      [theme.breakpoints.only('xs')]: {
        marginTop: "30px",
      },
      borderRadius: "14px",
      boxShadow: "0px 2px 20px rgba(0,0,0, 0.209053)",
      backgroundColor: "#FFFFFF",
      '& .formSection': {
        width: "100%",
        '& .heading1': {
          fontSize: "28px",
          fontWeight: 700,
          color: "#00152E",
          marginBottom: "23px",
          paddingRight: "12px",
          [theme.breakpoints.only('xs')]: {
            paddingRight: 0,
          },
        },
        '& .heading2': {
          fontSize: "16px",
          fontWeight: 400,
          color: "#00152E",
          marginBottom: "23px",
        },
        '& .formGroup': {
          '& .formLabel': {
            fontSize: "18px",
            fontWeight: 700,
            color: "#00152E",
          },
          '& .formLabelHint': {
            fontSize: "13px",
            fontWeight: 400,
            color: "#00152E",
            marginTop: "3px",
          },
          '& .inputContainer': {
            width: "189px",
            marginTop: "12px",
          },
        },
        '& .captchaSection': {
          width: "100%",
          margin: "22px 0px",
        },
        '& .buttonSection': {
          marginBottom: "2px",
          '& .blueBtn': {
            minWidth: 0,
            fontSize: "16px",
            fontWeight: 700,
            color: "#FFFFFF",
            backgroundColor: "#02489D",
            padding: "8px 24px",
            borderRadius: "6px",
          },
        },
        '& .progressSection': {
          '& .MuiLinearProgress-root': {
            margin: "-31px",
            marginTop: "0px",
          },
        },
        '& .correctSection': {
          display: "flex",
          gap: "10px",
          alignItems: "center",
          backgroundColor: "FFFFFF",
          color: "#00152E",
          margin: "29px -31px",
          padding: "18px 31px",
          '&.withError': {
            backgroundColor: '#D55152',
            //borderRadius: "0px 0px 14px 14px",
            color: "#FFFFFF",
          },
          '& .icon': {
            height: "24px",
          },
          '& .text': {
            fontSize: "16px",
            fontWeight: 700,
          },
        },
      },
    },
  },
  textFieldInput: {
    width: "100%",
    height: "44px",
    fontSize: 16,
    fontWeight: 600,
    backgroundColor: "#FFFFFF",
    color: "#00122A",
    border: "2px solid #C2C2C2",
    borderRadius: "6px",
  },
  hiddenComponent: {
    display: "none",
  }
}));

const PCRdownloadWidget = () => {
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const classes = useStyles();

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useLayoutEffect(() => {
    // Get the element by its ID
    const element = document.getElementById('root');
    // Check if the element exists
    if (element) {
      // Add the CSS class to the element
      element.classList.add('noScroll');
    }
    // Clean up when the component unmounts
    return () => {
      element?.classList.remove('noScroll');
    };
  }, []);

  const [dateOfBirth, setDateOfBirth] = useState('');
  const [accessCode, setAccessCode] = useState('');
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [token, settoken] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [progressbar, setProgressbar] = useState(false);
  const [triggerAPI, setTriggerAPI] = React.useState(false);
  const [generateChartPDF, setGenerateChartPDF] = React.useState(false);
  const [pcrId, setPcrId] = React.useState("");
  const [loadingPdf, setLoadingPdf] = React.useState(false);

  const handleRecaptchaChange = (token: any) => {
    settoken(token);
    //console.log('reCAPTCHA token:', token);
  };
  const validate = () => {
    if (!dateOfBirth || !accessCode || token === null) {
      setHasError(true);
      setErrorMessage('All fields are required');
      return true;
    }

    if (
      !/^(\d{2})\/(\d{2})\/(\d{4})$/.test(dateOfBirth) ||
      accessCode.length !== 8
    ) {
      setHasError(true);
      setErrorMessage('No patient care record could be found with these details');
      return true;
    }
    return false;
  }
  const handleDownload = async () => {
    setHasError(false);
    setErrorMessage("");
    const val = false;//validate();
    if (!val) {
      setProgressbar(true);
      setDisabled(true);
      const res = await api.downloadpcr('accesscode=' + accessCode + '&dob=' + dateOfBirth, null);
      if (res.hasError === false) {
        await api.downloadpcrfile('id=' + res.result, null)
          .then((response) => {
            setProgressbar(false);
            setDisabled(false);
            var pdf = res.result.replace(".pdf", "-PCRPDF");
            window.open(response.result)
            //downloadPdf(response.result,pdf)
            setAccessCode("");
            setDateOfBirth("");
            settoken(null);
          })
          .catch((error) => {
            setProgressbar(false);
            setDisabled(false);
            setHasError(true);
            setErrorMessage('An error has occurred. Please try again later.');
            //console.error(error);
          });
      }
      else {
        setProgressbar(false);
        setDisabled(false);
        setHasError(true);
        setErrorMessage(res.message);
        //console.log(res);
        //console.log('Download clicked!');
      }
    }

  };
  const downloadPdf = (base64String: any, fileName: any) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(pdfBlob);
    // let link = document.createElement('a');
    // let reader = new FileReader();
    // reader.readAsDataURL(pdfBlob); // converts the blob to base64 and calls onload
    // reader.onload = function() {
    //   link.href = pdfUrl; // data url
    //   link.click();
    // };
    blobToBase64(pdfBlob).then(res => {
      //console.log(res);
      var base64String: any = res;
      var pdf = base64String.split(",")[1];
      var encodepdf = window.btoa("data:application/pdf;base64," + pdf);
      window.open("data:application/pdf;base64," + pdf, '_blank');
      window.location.reload();
    });
    //const link = document.createElement('a');

    //link.href = pdfUrl;

    //link.download = fileName;

    //window.open(pdfUrl);
    //link.click();

    //URL.revokeObjectURL(pdfUrl);

  };
  const blobToBase64 = (blob: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };
  const handleAccessCodeChange = (event: any) => {
    const inputAccessCode = event.target.value;
    const truncatedAccessCode = inputAccessCode.slice(0, 8);

    setAccessCode(truncatedAccessCode);
  };

  const onDownloadClick = async () => {
    try {
      const val = false;//validate();
      if (!val) {
        setProgressbar(true);
        setHasError(false);
        setErrorMessage("");
        const res = await api.CheckChartPDFExist('pcrId=' + pcrId + '&accesscode=' + accessCode + '&dob=' + dateOfBirth, null);
        if (res.errorRaised === false) {
          if (res.errorRaised === false && res.result === false) {
            setPcrId(res.pcrId)
            setGenerateChartPDF(true)
          }
          else {
            setGenerateChartPDF(false)
            handleDownload();
          }
        }
        else {
          setHasError(true);
          setErrorMessage(res.message);
        }
      }
    }
    catch (error) {
      setProgressbar(false);
      setHasError(true);
      setErrorMessage('An error has occurred. Please try again later.');
    }
  };

  React.useEffect(() => {
    if(triggerAPI){
      handleDownload();
    }

    return () => {
      setTriggerAPI(false);
    }
  }, [triggerAPI,setTriggerAPI])


  return (
    <div className={classes.root}>
      <div className={"container"}>
        <div className={"formSection"}>
          <div className={"heading1"}>
            Download Patient Care Record
          </div>
          <div className={"heading2"}>
            Patient care record is available for 1 hour following handover of care by SMA.
          </div>
          <div className={"formGroup"} style={{ paddingBottom: "18px" }}>
            <div className={"formLabel"}>Patient Date Of Birth</div>
            <div className={"inputContainer"}>
              <InputMask
                mask="99/99/9999"
                placeholder="DD / MM / YYYY"
                value={dateOfBirth}
                onChange={(e) => setDateOfBirth(e.target.value)}
              >
                {(inputProps: any) => (
                  <TextField
                    type="text"
                    {...inputProps}
                    variant="outlined"
                    InputProps={{ classes: { root: classes.textFieldInput } }}
                  />
                )}
              </InputMask>
            </div>
          </div>
          <div className={"formGroup"}>
            <div className={"formLabel"}>Access Code</div>
            <div className={"formLabelHint"}>SMA caregivers will have shared this code with you.</div>
            <div className="inputContainer">
              <TextField
                type="text"
                value={accessCode}
                onChange={handleAccessCodeChange}
                variant="outlined"
                InputProps={{ classes: { root: classes.textFieldInput } }}
              />
            </div>
          </div>
          <div className={"captchaSection"}>
            <ReCAPTCHA
              sitekey={consts.RecaptchaV2SiteKey}
              onChange={handleRecaptchaChange}
            />
          </div>

          {hasError && (<div className={`correctSection ${hasError ? "withError" : ""}`}>
            <img src={errorsymbol} className={"icon"} alt="error" />
            <div className={"text"}>{errorMessage}</div>
          </div>)}

          <div className={"buttonSection"}>
            <Button
              disabled={disabled}
              className={"blueBtn"}
              variant="contained"
              fullWidth
              onClick={onDownloadClick}
            >
              Download
            </Button>
          </div>

          {progressbar && (<div className={"progressSection"}>
            <h5>Please wait while your PCR is being generated.</h5>
            <LinearProgress />
          </div>)}
        </div>
        {generateChartPDF && (
        <div className="hiddenComponent">
          <PCRObservationChartPDF pcrId={pcrId} setTriggerAPI={setTriggerAPI} />
        </div>
      )}
      </div>
    </div>
  );
};

export default PCRdownloadWidget;
